import { createListenerMiddleware, createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { readStorageValue, saveStorageValue } from 'hooks/use-storage/use-storage.utils';
import { RootState } from 'store/root.types';

export const searchHistorySliceName = 'searchHistory';

type SearchHistory = {
  history: string[];
};

export const getInitialState = () => {
  const history = readStorageValue<SearchHistory>({
    storageKey: searchHistorySliceName,
    fallbackValue: { history: [] },
    validate: (persistedValue): persistedValue is SearchHistory => {
      return (
        typeof persistedValue === 'object' &&
        persistedValue !== null &&
        'history' in persistedValue &&
        Array.isArray(persistedValue.history) &&
        persistedValue.history.every((item) => typeof item === 'string')
      );
    },
  });

  return { history };
};

export const searchHistorySlice = createSlice({
  name: searchHistorySliceName,
  initialState: getInitialState().history,
  reducers: {
    setSearchHistory(state, action: PayloadAction<string[]>) {
      state.history = action.payload;
    },
    reset(state) {
      state.history = [];
    },
  },
});

export type SearchHistorySlicePayload = ReturnType<typeof searchHistorySlice.getInitialState>;
export default searchHistorySlice.reducer;
export const { setSearchHistory, reset } = searchHistorySlice.actions;

export const selectSearchHistory = (state: RootState) => {
  return state[searchHistorySliceName].history;
};

export const searchHistoryListenerMiddleware = createListenerMiddleware();
searchHistoryListenerMiddleware.startListening({
  matcher: isAnyOf(setSearchHistory),
  effect: (_action, listenerApi) => {
    saveStorageValue({ storageKey: searchHistorySliceName, value: (listenerApi.getState() as RootState)[searchHistorySliceName] });
  },
});
